import { render, staticRenderFns } from "./OperatorDataTab.vue?vue&type=template&id=20e93e16&scoped=true&"
import script from "./OperatorDataTab.vue?vue&type=script&lang=ts&"
export * from "./OperatorDataTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e93e16",
  null
  
)

export default component.exports